import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'
import { useApiErrorHandler } from '../../../useApiErrorHandler'

interface CreateKeepContactData {
  name: string
  description?: string
  contactAccountId: string
  date: string // ISO date string
  rrule?: string | null
  location?: {
    place: string
    city?: string
    country?: string
    state?: string
    region?: string
  } | null
  hasReminder?: boolean
}

const createKeepContact = async (data: CreateKeepContactData): Promise<string> => {
  const { data: responseData } = await api.post<string>('/keep-contact', data)
  return responseData
}

export const useCreateKeepContact = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()
  const handleApiError = useApiErrorHandler()

  return useMutation<string, Error, CreateKeepContactData>({
    mutationFn: createKeepContact,
    onSuccess: async () => {
      showSuccessToast(t('toast.success'), t('toast.reminderCreated'))
      await queryClient.invalidateQueries({ queryKey: ['keep-contacts'] })
    },
    // Free accounts get 402 PLAN_FEATURE_REMINDERS_DISABLED /
    // PLAN_LIMIT_REMINDERS_REACHED → paywall instead of a raw error toast.
    onError: handleApiError,
  })
}
